import React from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import { AuthContextProvider } from './context/AuthContext'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProviderContext } from './context/ThemeContext'

const rootElement = document.getElementById('root')
const root = createRoot(rootElement)

root.render(
  <React.StrictMode>
    <AuthContextProvider>
      <ThemeProviderContext>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProviderContext>
    </AuthContextProvider>
  </React.StrictMode>
)
